import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslations from "./locales/en/translation";
import ruTranslations from "./locales/ru/translation";
import hyTranslations from "./locales/hy/translation";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      ru: { translation: ruTranslations },
      hy: { translation: hyTranslations}
    },
    fallbackLng: "hy",
    detection: {
      // порядок проверки языков
      order: ["localStorage", "cookie", "navigator", "htmlTag", "path", "subdomain"],
      // куда сохраняем выбранный язык
      caches: ["localStorage", "cookie"],
      // ключ в localStorage
      lookupLocalStorage: "i18nextLng",
    },
    react: { useSuspense: false },
    interpolation: { escapeValue: false },
  });

export default i18n;
